//Master Data
const masterTableFields = [
    {title: "User Id",
        is_searchable: true,
        class_name: 'w-110p',
        field: {
            type: "number",
            name: "user_id"
        },
        fetch_key: "user_id"
    },
    {title: "Email",
        is_searchable: true,
        field: {
            type: "text",
            name: "email"
        },
        fetch_key: "user_email.email"
    },
    {title: "PortAhead Expiry Date",
        is_searchable: true,
        field: {
            type: "select",
            name: "port_validity_id"
        },
        option_label: "validity",
        option_val: "id",
        fetch_key: "port_expiry_at",
        data_type: {
            type: "expiry_at"
        }
    },
    {title: "GLOSCO Expiry Date",
        is_searchable: true,
        field: {
            type: "select",
            name: "glosco_validity_id"
        },
        option_label: "validity",
        option_val: "id",
        fetch_key: "glosco_expiry_at",
        data_type: {
            type: "expiry_at"
        }
    },
    {title: "SS Expiry Date",
        is_searchable: true,
        field: {
            type: "select",
            name: "ss_validity_id"
        },
        option_label: "validity",
        option_val: "id",
        fetch_key: "ss_expiry_at",
        data_type: {
            type: "expiry_at"
        }
    },
    {title: "Name",
        is_searchable: true,
        field: {
            type: "text",
            name: "name"
        },
        fetch_key: "name"
    },
    {title: "Mobile Number",
        is_searchable: true,
        class_name: 'w-250p',
        field: {
            type: "text",
            name: "mobile_number"
        },
        fetch_key: "user_mobile.full_mobile"
    },
    {title: "School",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "school_id"
        },
        accessRoleIds: [2, 7],
        option_label: "school_name",
        option_val: "id",
        fetch_key: "school_name"
    },
    {title: "Branch",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "branch_id"
        },
        accessRoleIds: [2, 7],
        option_label: "branch_name",
        option_val: "id",
        fetch_key: "branch_name"
    },
    {title: "Class",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "class_id"
        },
        option_label: "class_name",
        option_val: "id",
        fetch_key: "class_name"
    }
];

const fieldValuesValidity = {
    user_ids: '',
    service_id: '',
    user_ids_array: [],
    expiry_date: ''
};

const fieldUpdateValidity = [
    {colMd: "5", label: "Services", required: true, type: "select", name: "service_id", placeholderData: ["Select Services"]},
    {colMd: "3", label: "Expiry Date", required: true, type: "date", name: "expiry_date", date_type: "future", placeholderData: []},
    {colMd: "12", label: "User Ids", required: true, type: "text", name: "user_ids", placeholderData: ["Ids Separated by comma, Ex: 123,456,789"]},
];

const fieldValidationValidity = {
    service_id: 'required||Services',
    user_ids: 'required||User Ids',
    expiry_date: 'required'
};

export {
    masterTableFields,
    fieldValuesValidity,
    fieldUpdateValidity,
    fieldValidationValidity
};